module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "detail-layout"
  }, [_c('div', {
    staticClass: "combo-table"
  }, [_vm._m(0), _vm._l((_vm.comboMedsEvent), function(med) {
    return _c('div', {
      staticClass: "combo-row"
    }, [_c('div', {
      staticClass: "combo-cell"
    }, [_vm._v(_vm._s(med.child_medication.generic_name) + " ")]), _c('div', {
      staticClass: "combo-cell"
    }, [_vm._v(_vm._s(_vm._f("fetchedZh")(med.fetched)) + " ")]), _c('div', {
      staticClass: "combo-cell"
    }, [(med.event) ? _c('span', [_vm._v(_vm._s(med.event.employee_name) + " 於 " + _vm._s(_vm._f("timeFromNow")(med.event.record_time)) + "取 " + _vm._s(-(med.event.number1)) + " 單位藥量")]) : _vm._e()])])
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "combo-table--head"
  }, [_c('div', {
    staticClass: "combo-cell"
  }, [_vm._v("藥名")]), _c('div', {
    staticClass: "combo-cell"
  }, [_vm._v("取藥狀況")]), _c('div', {
    staticClass: "combo-cell"
  }, [_vm._v("取藥事件")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1183d55c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/ADCManagement/ScheduleDetail.vue
// module id = 1391
// module chunks = 1